import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { ApiService } from './services/api.service';
import { AuthenticationService } from './services/authentication.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { JwtInterceptor } from './services/interceptors/jwt.interceptor';
import { NgxMaskModule } from 'ngx-mask';
import { SignUpModule } from './views/sign-up/sign-up.module';
import { ProfileModule } from './views/profile/profile.module';
import { SafetyEyewearModule } from './views/products/safety-eyewear/safety-eyewear.module';
import { SafetyShoesModule } from './views/products/safety-shoes/safety-shoes.module';
import { RespiratorsModule } from './views/products/respirators/respirators.module';
import { ComputerEyewearModule } from './views/products/computer-eyewear/computer-eyewear.module';
import { FavoritesModule } from './views/products/favorites/favorites.module';
import { BenefitsModule } from './views/benefits/benefits.module';
import { AccessoriesModule } from './views/products/accessories/accessories.module';
import { PrescriptionModule } from './views/prescription/prescription.module';
import { PoliciesModule } from './views/policies/policies.module';
import { OrdersModule } from './views/orders/orders.module';
import { LensSelectionModule } from './views/lens-selection/lens-selection.module';
import { DashboardModule } from './views/dashboard/dashboard.module';
import { CheckoutModule } from './views/checkout/checkout.module';
import { CartModule } from './views/cart/cart.module';
import { FaqsModule } from './views/faqs/faqs.module';
import { EmployeeRouteInterceptor } from './services/interceptors/employeeRoute.interceptor';
import { NotFoundComponent } from './views/error-pages/not-found/not-found.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { ngxUiLoaderConfig } from './config/ngx-ui-loader-config';
import { environment } from 'src/environments/environment';
import { NgxStripeModule } from 'ngx-stripe';
import { ToastrModule } from 'ngx-toastr';
import { NgxToastrConfig } from './config/ngx-toastr-config';
import { ModalsModule } from './ui-widgets/modals/modals.module';
import { DatePipe } from '@angular/common';
import { UserIdleModule } from 'angular-user-idle';
import { EYE_USER_IDLE_CONFIG } from './config';
import { TelehealthConsentModule } from './views/telehealth-consent/telehealth-consent.module';
import { SignOutModule } from './views/sign-out/sign-out.module';
import { FormContainersModule } from './ui-widgets/form-containers/form-containers.module';
import { ContactInfoModule } from './views/contact-info/contact-info.module';
import { AddressInfoModule } from './views/address-info/address-info.module';
import { ErrorHandlerModule } from './handlers/error-handler.module';
import { ErrorInterceptor } from './services/interceptors/error.interceptor';
import { ShoeInsolesModule } from './views/products/shoe-insoles/shoe-insoles.module';
import { GuidedOptModalComponent } from './ui-widgets/guided-opt-modal/guided-opt-modal.component';
import { SingleVisionComponent } from './ui-widgets/guided-opt-modal/single-vision/single-vision.component';
import { BfProgVisionComponent } from './ui-widgets/guided-opt-modal/bf-prog-vision/bf-prog-vision.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({ declarations: [
        AppComponent,
        NotFoundComponent,
        GuidedOptModalComponent,
        SingleVisionComponent,
        BfProgVisionComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,        
        AppRoutingModule,
        ReactiveFormsModule,
        SignUpModule,
        ProfileModule,
        SafetyEyewearModule,
        SafetyShoesModule,
        ShoeInsolesModule,
        RespiratorsModule,
        ComputerEyewearModule,
        AccessoriesModule,
        FavoritesModule,
        BenefitsModule,
        PrescriptionModule,
        PoliciesModule,
        OrdersModule,
        LensSelectionModule,
        DashboardModule,
        CheckoutModule,
        TelehealthConsentModule,
        SignOutModule,
        CartModule,
        FaqsModule,
        FormsModule,
        RouterModule,
        ContactInfoModule,
        AddressInfoModule,
        NgxMaskModule.forRoot(),
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
        NgxStripeModule.forRoot(environment.stripe_pk),
        ToastrModule.forRoot(NgxToastrConfig),
        ModalsModule,
        FormContainersModule,
        UserIdleModule.forRoot(EYE_USER_IDLE_CONFIG),
        ErrorHandlerModule,
        FontAwesomeModule], providers: [
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EmployeeRouteInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true,
        },
        ApiService,
        AuthGuard,
        AuthenticationService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
